<template>
  <div class="question-padding">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style lang="postcss">
.question-padding {
  display: grid;
  height: 100%;
  padding: var(--attest-spacing-4);
  grid-template-rows: auto 1fr;
}
</style>
